import { AsyncPipe, CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DeviceOrientationService } from '../../../core/services/device-orientation.service';

@Component({
  selector: 'app-rotation-warning',
  standalone: true,
  imports: [CommonModule, AsyncPipe, TranslateModule],
  templateUrl: './rotation-warning.component.html',
  styleUrl: './rotation-warning.component.scss',
})
export class RotationWarningComponent {
  constructor(public deviceService: DeviceOrientationService) {}
}
